import { startAuth } from '../lib/slack.es6';


export default Backbone.View.extend({
    el: '.addSlack',
    initialize: function (options) {
        this.listenTo(this.model, 'featureChange:slack', this.render);
        this.listenTo(this.model, 'stat', this.render);
        this.error = $('.addSlack__error');
        this.render();
    },
    events: {
        'click .addSlack__button': 'clickButton'
    },
    render: function () {
        this.$el.toggleClass('addSlack--enabled', this.model.isSlackOauthAllowed());
    },
    clickButton: function (e) {
        this.hideError();
        startAuth(this.model, {
            onClose: _.bind(this.hideError, this),
            onSuccess: _.bind(function (response) {
                this.hideError();
                this.model.setFocusOnMakeServer(response.cid);
            }, this),
            onError: _.bind(function (message) {
                if (message) {
                    this.showError(message);
                } else {
                    this.hideError();
                }
            }, this)
        });
    },
    hideError: function () {
        this.error.hide().text('');
    },
    showError: function (message) {
        this.error.text(message).show();
    }
});



// WEBPACK FOOTER //
// ./app/src/view/addslackview.es6